function scroll() {
    $('html, body').animate({
        scrollTop: $(".carzInfoBlock.bottomBlock").offset().top
    }, 500);
}

export function initReadMoreScroll() {
    const buttons = [...document.querySelectorAll('.js_readMoreScroll')];

    buttons.forEach(button => button.addEventListener('click', scroll));
}

$(document).ready(initReadMoreScroll);
